<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <vue-perfect-scrollbar class="customer-status--scrollbar">
              <v-data-table
                :headers="headers"
                :items="series"
                hide-actions
                no-data-text="No se encontraron registros"
                class="bordered mx-4 b-borders hovereable"
              >
                <template slot="headerCell" slot-scope="props" class="k-orange-linear">
                  <v-tooltip bottom>
                    <span slot="activator">
                      {{ props.header.text }}
                    </span>
                    <span>
                      {{ props.header.descrip }}
                    </span>
                  </v-tooltip>
                </template>
                <template  slot="items" slot-scope="props">
                  <td>
                    {{ formatDate(props.item.date, 'YYYY-MM-DD', 'DD/MM/YYYY') }}
                  </td>
                  <td>
                    {{ new Intl.NumberFormat('es-VE').format(props.item.channels.email) }}
                  </td>
                  <td>
                    {{ new Intl.NumberFormat('es-VE').format(props.item.channels.sms) }}
                  </td>
                  <td>
                    {{ new Intl.NumberFormat('es-VE').format(props.item.channels.bot) }}
                  </td>
                  <td>
                    {{ new Intl.NumberFormat('es-VE').format(props.item.channels.ivr) }}
                  </td>
                  <td>
                    {{ new Intl.NumberFormat('es-VE').format(props.item.channels.human) }}
                  </td>
                  <td>
                    {{ new Intl.NumberFormat('es-VE').format(props.item.channels.manualHuman )}}
                  </td>
                </template>
                <template slot="footer" v-if="series.length > 0" >
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    <strong>{{new Intl.NumberFormat('es-VE').format(totalEmail)}}</strong>
                  </td>
                  <td>
                    <strong>{{new Intl.NumberFormat('es-VE').format(totalSms)}}</strong>
                  </td>
                  <td>
                    <strong>{{new Intl.NumberFormat('es-VE').format(totalBot)}}</strong>
                  </td>
                  <td>
                    <strong>{{new Intl.NumberFormat('es-VE').format(totalIvr)}}</strong>
                  </td>
                  <td>
                    <strong>{{new Intl.NumberFormat('es-VE').format(totalHuman)}}</strong>
                  </td>
                  <td>
                    <strong>{{new Intl.NumberFormat('es-VE').format(totalManualHuman)}}</strong>
                  </td>
                </template>
              </v-data-table>
            </vue-perfect-scrollbar>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import _ from 'lodash';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import formatDateMixin from '@/mixins/formatDate';
import EventBus from '@/event-bus';

const qs = require('qs');

export default {
  components: {
    VuePerfectScrollbar,
  },
  mixins: [
    formatDateMixin,
  ],
  props: {
    filters: {
      required: true,
      type: Object,
    },
  },
  created() {
    EventBus.$on('historicGraphicSeries', (series) => {
      this.series = series;
    });
    EventBus.$on('historicGraphicReload', () => {
      this.searchData();
    });
  },
  destroyed() {
    EventBus.$off('historicGraphicSeries');
    EventBus.$off('historicGraphicReload');
  },
  data() {
    return {
      series: [],
      headers: [
        {
          text: 'Fecha',
          align: 'left',
          value: 'date',
          descrip: 'Fecha de gestion',
        },
        {
          text: 'Email',
          align: 'left',
          value: 'email',
          descrip: 'Canal de gestion',
        },
        {
          text: 'Sms',
          align: 'left',
          value: 'sms',
          descrip: 'Canal de gestion',
        },
        {
          text: 'Bot',
          align: 'left',
          value: 'bot',
          descrip: 'Canal de gestion',
        },
        {
          text: 'Ivr',
          align: 'left',
          value: 'ivr',
          descrip: 'Canal de gestion',
        },
        {
          text: 'Call - Discador',
          align: 'left',
          value: 'human',
          descrip: 'Canal de gestión',
        },
        {
          text: 'Call - Individual',
          align: 'left',
          value: 'manual_human',
          descrip: 'Canal de gestión',
        },
      ],
      totalBot: 0,
      totalEmail: 0,
      totalSms: 0,
      totalIvr: 0,
      totalHuman: 0,
      totalManualHuman: 0,
    };
  },
  methods: {
    generateReport(date = null) {
      EventBus.$emit('startListenEvent');
      const data = {
        filters: { ...this.filters },
        functionName: 'managementTotal',
      };
      if (date) {
        data.filters.type = 'date';
        data.filters.from = date;
      } else {
        data.filters.from = this.filters.from;
        data.filters.type = 'month';
      }
      this.axios.post('/reports', data).then(() => {
        EventBus.$emit('infoModal',
          'Se esta generando su archivo, se le informara cuando este listo el reporte, por favor espere.',
          'fas fa-check-double');
      });
    },
    searchData() {
      this.axios.get(`/notification_schedules/historic_metrics?${qs.stringify(this.filters)}`).then((response) => {
        this.series = [];
        this.totalBot = 0;
        this.totalEmail = 0;
        this.totalSms = 0;
        this.totalIvr = 0;
        this.totalHuman = 0;
        this.totalManualHuman = 0;
        const dates = _.groupBy(response.data, 'date');
        const keys = Object.keys(dates);
        keys.forEach((item) => {
          const obj = {
            date: item,
            channels: {
              email: 0,
              sms: 0,
              bot: 0,
              ivr: 0,
              human: 0,
              manualHuman: 0,
            },
          };
          const email = dates[item].filter(channel => channel.channel_id === 1);
          if (email.length) {
            // eslint-disable-next-line
            obj.channels.email = email.reduce((total, value) => total + parseInt(value.quantity), obj.channels.email);
            this.totalEmail += obj.channels.email;
          }
          const sms = dates[item].filter(channel => channel.channel_id === 2);
          if (sms.length) {
            // eslint-disable-next-line
            obj.channels.sms = sms.reduce((total, value) => total + parseInt(value.quantity), obj.channels.sms);
            this.totalSms += obj.channels.sms;
          }
          const bot = dates[item].filter(channel => channel.channel_id === 4);
          if (bot.length) {
            // eslint-disable-next-line
            obj.channels.bot = bot.reduce((total, value) => total + parseInt(value.quantity), obj.channels.bot);
            this.totalBot += obj.channels.bot;
          }
          const ivr = dates[item].filter(channel => channel.channel_id === 3);
          if (ivr.length) {
            // eslint-disable-next-line
            obj.channels.ivr = ivr.reduce((total, value) => total + parseInt(value.quantity), obj.channels.ivr);
            this.totalIvr += obj.channels.ivr;
          }
          const human = dates[item].filter(channel => channel.channel_id === 5);
          if (human.length) {
            // eslint-disable-next-line
            obj.channels.human = human.reduce((total, value) => total + parseInt(value.quantity), obj.channels.human);
            this.totalHuman += obj.channels.human;
          }
          const manualHuman = dates[item].filter(channel => channel.channel_id === 6);
          if (manualHuman.length) {
            // eslint-disable-next-line
            obj.channels.manualHuman = manualHuman.reduce((total, value) => total + parseInt(value.quantity), obj.channels.manualHuman);
            this.totalManualHuman += obj.channels.manualHuman;
          }
          this.series.push(obj);
        });
      });
    },
  },
  watch: {
    'filters'() { // eslint-disable-line
      this.searchData();
    },
  },
};
</script>

<style scoped>
.customer-status--scrollbar {
  max-height: 420px;
  min-height: 420px;
}
</style>




// WEBPACK FOOTER //
// src/components/panel/management/Historic.vue